__turbopack_context__.v({
  "button": "Contacts-module__KddykW__button",
  "container": "Contacts-module__KddykW__container",
  "form": "Contacts-module__KddykW__form",
  "infoBlock": "Contacts-module__KddykW__infoBlock",
  "infoItem": "Contacts-module__KddykW__infoItem",
  "input": "Contacts-module__KddykW__input",
  "label": "Contacts-module__KddykW__label",
  "link": "Contacts-module__KddykW__link",
  "subtitle": "Contacts-module__KddykW__subtitle",
  "textarea": "Contacts-module__KddykW__textarea",
  "title": "Contacts-module__KddykW__title",
});
